<div *ngIf="pUser" (click)="goToUser(pUser)" class="result pointer list-group-item list-group-item-action d-flex justify-content-between">
     <base64-image [borderRadiusRem]="5" [fileId]="pUser.profile_image_file_id" class="profile-image"></base64-image>
    <div class="ms-3">
        <div class="">
            {{ pUser.display_name }}
        </div>
        <div class="small text-muted">
            {{ pUser.tag_line }}
        </div>
    </div>
</div>
